// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import isEmpty from 'lodash/isEmpty';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { getViewportInfo, isClient } from '@tcp/core/src/utils';
import LazyLoadHOC from '@tcp/web/src/components/common/hoc/LazyLoad/LazyLoadNew';
import RecommendationSkeleton from '@tcp/core/src/components/common/molecules/Recommendations/views/RecommendationSkeleton.view';
import style from '@tcp/core/src/components/common/molecules/Recommendations/styles/Recommendations.style';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary';
import DyRecommendationCarousel from './DyRecommendationCarousel.view';

const renderRecommendationCarousel = (props) => {
  const {
    className,
    title,
    data,
    isHideOriginalPriceAndMarchantTagEnabled,
    page,
    currencySymbol,
    currencyAttributes,
    onQuickViewOpenClick,
    isAddedToBag,
    isBackToQuickviewCTAEnabled,
    isQvModalOpen,
    closeQvModal,
    serverTime,
    promotionsData,
    isPromoMsgEnabledRecommendation,
    isDynamicBadgeEnabledAbtest,
    isTransparentImageSizeReduceEnabled,
    isBIACombinedCarouselEnabled,
    fromBIA,
    isBagPage,
    bagItemCount,
    recommendationSelector,
    isPdpPlaProducts,
    accordionHeader,
    isPDP,
    isHomePage,
    fromOrderDetails,
    subHeaderLabel,
    sendTrackEventsToDy,
  } = props;
  return (
    <div className={className}>
      <DyRecommendationCarousel
        title={title}
        products={data}
        isHideOriginalPriceAndMarchantTagEnabled={isHideOriginalPriceAndMarchantTagEnabled}
        page={page}
        currencySymbol={currencySymbol}
        currencyAttributes={currencyAttributes}
        onQuickViewOpenClick={onQuickViewOpenClick}
        isAddedToBag={isAddedToBag}
        isBackToQuickviewCTAEnabled={isBackToQuickviewCTAEnabled}
        isQvModalOpen={isQvModalOpen}
        closeQvModal={closeQvModal}
        serverTime={serverTime}
        promotionsData={promotionsData}
        isPromoMsgEnabledRecommendation={isPromoMsgEnabledRecommendation}
        isDynamicBadgeEnabledAbtest={isDynamicBadgeEnabledAbtest}
        isTransparentImageSizeReduceEnabled={isTransparentImageSizeReduceEnabled}
        isBIACombinedCarouselEnabled={isBIACombinedCarouselEnabled}
        fromBIA={fromBIA}
        isBagPage={isBagPage}
        bagItemCount={bagItemCount}
        recommendationSelector={recommendationSelector}
        isPdpPlaProducts={isPdpPlaProducts}
        accordionHeader={accordionHeader}
        isPDP={isPDP}
        isHomePage={isHomePage}
        fromOrderDetails={fromOrderDetails}
        subHeaderLabel={subHeaderLabel}
        sendTrackEventsToDy={sendTrackEventsToDy}
      />
    </div>
  );
};

const DyRecommendations = (props) => {
  const {
    title,
    data,
    isBagPage,
    isLoading,
    isPDP,
    isHomePage,
    bagItemCount,
    topRecommendationOOS,
  } = props;

  const showSkeletonWithLazyLoad = isPDP || isBagPage || isHomePage;
  const isMobile = isClient() ? getViewportInfo().isMobile : false;
  const offset = isMobile ? 200 : 400;

  if (isLoading && isEmpty(data) && !topRecommendationOOS) {
    return showSkeletonWithLazyLoad ? (
      <div className="hide-skeleton-largeDesktop">
        {<RecommendationSkeleton {...props} cartItemsCount={bagItemCount} />}
      </div>
    ) : (
      <></>
    );
  }

  if (isEmpty(data) || (isLoading && topRecommendationOOS)) {
    return null;
  }

  return showSkeletonWithLazyLoad ? (
    <LazyLoadHOC
      id={`recommendation-lazy-load-${title}`}
      offset={offset}
      loadingComponent={<RecommendationSkeleton {...props} cartItemsCount={bagItemCount} />}
    >
      {renderRecommendationCarousel(props)}
    </LazyLoadHOC>
  ) : (
    renderRecommendationCarousel(props)
  );
};

export { DyRecommendations as DyRecommendationsVanilla };
export default errorBoundary(withStyles(DyRecommendations, style));
